import {
  modifyScaleSavingCurrentAspectRatioByWidth,
  modifyScaleSavingCurrentAspectRatioByHeight,
  modifyScaleIfNeeded,
} from "../utils/canvasUtils";
import { Object } from "../types/canvasTypes";

export function checkSizeChanging(modifiedPropertyName: string | undefined) {
  const isWidthChanged = modifiedPropertyName === "width";
  const isHeightChanged = modifiedPropertyName === "height";
  const isSizeChanged = isWidthChanged || isHeightChanged;

  return {
    isWidthChanged,
    isHeightChanged,
    isSizeChanged,
  };
}

export function modifyScaleConsideringSizeRatioLockingIfNeeded(
  object: Object,
  {
    isSizeRatioLocked,
    isSizeChanged,
    isWidthChanged,
    width,
    height,
  }: {
    isSizeRatioLocked?: boolean;
    isSizeChanged: boolean;
    isWidthChanged: boolean;
    width: number;
    height: number;
  }
) {
  if (!isSizeChanged) return;

  if (isSizeRatioLocked) {
    if (isWidthChanged) {
      modifyScaleSavingCurrentAspectRatioByWidth(object, width);
    } else {
      modifyScaleSavingCurrentAspectRatioByHeight(object, height);
    }
  } else {
    modifyScaleIfNeeded(object, width, height);
  }
}
